"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ComponentWrapper = _interopRequireDefault(require("../../helpers/ComponentWrapper"));
var _Toggle = _interopRequireDefault(require("../../helpers/Toggle"));
var _Tabs = _interopRequireDefault(require("../../Tabs/Tabs"));
var _Card = _interopRequireDefault(require("../../Card/Card"));
var _Button = _interopRequireDefault(require("../../Button/Button"));
var _Modal = _interopRequireDefault(require("../../Modal"));
var _constants = require("../../constants");
var _Ratings = _interopRequireDefault(require("./components/Ratings"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FlexProductTabs = function FlexProductTabs(_ref) {
  var data = _ref.data;
  var filterOptions = data.tabs && data.tabs.map(function (tab) {
    return {
      text: tab.tab_label,
      hasRatings: tab.hasRatings,
      content: tab.cards && tab.cards.map(function (_ref2) {
        var title = _ref2.title,
          subtitle = _ref2.subtitle,
          sections = _ref2.sections,
          image = _ref2.image;
        return {
          title: title,
          subtitle: subtitle,
          image: image,
          sections: sections && sections.map(function (_ref3) {
            var title = _ref3.title,
              list = _ref3.list;
            return {
              title: title,
              list: list.map(function (_ref4) {
                var text = _ref4.text,
                  crossed = _ref4.crossed,
                  bold = _ref4.bold,
                  modal = _ref4.modal;
                return {
                  text: text,
                  bold: bold,
                  crossed: crossed,
                  modal: modal
                };
              })
            };
          })
        };
      })
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], null, /*#__PURE__*/_react["default"].createElement(_Tabs["default"], {
    filterOptions: filterOptions,
    centerOptions: true
  }, function (_ref5) {
    var activeFilter = _ref5.activeFilter;
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "margin-top-md flex justify-center grid-gap-md flex-wrap"
    }, filterOptions[activeFilter].content && filterOptions[activeFilter].content.map(function (item) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: JSON.stringify(item),
        className: "max-width-xxxxs flex-grow"
      }, item.image ? /*#__PURE__*/_react["default"].createElement(_Card["default"], {
        className: "height-100%",
        template: "ImageCard",
        imageCardTemplate: "VerticalSplit",
        image: item.image
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-component"
      }, item.title && /*#__PURE__*/_react["default"].createElement("h2", {
        className: "text-md d8-u-color-primary d8-u-ls-sm"
      }, item.title), item.subtitle && /*#__PURE__*/_react["default"].createElement("p", {
        className: "d8-u-color-contrast-high text-sm d8-u-text-bold d8-u-ls-sm"
      }, item.subtitle), item.sections && item.sections.map(function (section) {
        return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
          key: JSON.stringify(section)
        }, /*#__PURE__*/_react["default"].createElement("h3", {
          className: "d8-u-font-size-base"
        }, section.title), /*#__PURE__*/_react["default"].createElement("ul", {
          className: "no-style"
        }, section.list && section.list.map(function (item) {
          return /*#__PURE__*/_react["default"].createElement("li", {
            key: JSON.stringify(item),
            className: (0, _classnames["default"])('d8-u-color-contrast-high', 'text-sm', item.crossed && 'd8-u-text-crossed', item.bold && 'd8-u-text-bold')
          }, item.modal ? /*#__PURE__*/_react["default"].createElement(_Toggle["default"], null, function (_ref6) {
            var on = _ref6.on,
              toggle = _ref6.toggle;
            return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
              onClick: toggle,
              buttonType: _constants.BUTTON_TYPES.BARE_CONTRAST_HIGH_NO_PADDING,
              text: item.text,
              icon: "info",
              iconFlip: true
            }), /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
              on: on,
              toggle: toggle
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: "text-component"
            }, /*#__PURE__*/_react["default"].createElement("h3", {
              className: "d8-u-ls-sm d8-u-color-primary text-md margin-bottom-md"
            }, item.text), /*#__PURE__*/_react["default"].createElement("p", null, item.modal))));
          }) : item.text);
        })));
      }))) : /*#__PURE__*/_react["default"].createElement(_Card["default"], {
        className: "height-100%"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-component"
      }, item.title && /*#__PURE__*/_react["default"].createElement("h2", {
        className: "text-md d8-u-color-primary d8-u-ls-sm"
      }, item.title), item.subtitle && /*#__PURE__*/_react["default"].createElement("p", {
        className: "d8-u-color-contrast-high text-sm d8-u-text-bold d8-u-ls-sm"
      }, item.subtitle), item.sections && item.sections.map(function (section) {
        return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
          key: JSON.stringify(section)
        }, /*#__PURE__*/_react["default"].createElement("h3", {
          className: "d8-u-font-size-base"
        }, section.title), /*#__PURE__*/_react["default"].createElement("ul", {
          className: "no-style"
        }, section.list && section.list.map(function (item) {
          return /*#__PURE__*/_react["default"].createElement("li", {
            key: JSON.stringify(item),
            className: (0, _classnames["default"])('d8-u-color-contrast-high', 'text-sm', item.crossed && 'd8-u-text-crossed', item.bold && 'd8-u-text-bold')
          }, item.modal ? /*#__PURE__*/_react["default"].createElement(_Toggle["default"], null, function (_ref7) {
            var on = _ref7.on,
              toggle = _ref7.toggle;
            return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
              onClick: toggle,
              buttonType: _constants.BUTTON_TYPES.BARE_CONTRAST_HIGH_NO_PADDING,
              text: item.text,
              icon: "info",
              iconFlip: true
            }), /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
              on: on,
              toggle: toggle
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: "text-component"
            }, /*#__PURE__*/_react["default"].createElement("h3", {
              className: "d8-u-ls-sm d8-u-color-primary text-md margin-bottom-md"
            }, item.text), /*#__PURE__*/_react["default"].createElement("p", null, item.modal))));
          }) : item.text);
        })));
      }))));
    })), filterOptions[activeFilter].hasRatings && /*#__PURE__*/_react["default"].createElement(_Ratings["default"], null));
  }));
};
FlexProductTabs.propTypes = {
  data: _propTypes["default"].object
};
var _default = exports["default"] = FlexProductTabs;